/**
 * Build query string for `GET /spot/v1/me/orders/open|history|trades`.
 * Omits empty / null / undefined keys.
 *
 * @param {Record<string, string | number | undefined | null>} params
 * @returns {string}
 */
export function buildSpotMeActivityQuery(params) {
  const u = new URLSearchParams();
  const add = (k, v) => {
    if (v === undefined || v === null || String(v).trim() === "") return;
    u.set(k, String(v));
  };

  add("page", params.page ?? 1);
  const rawSize = Number(params.page_size);
  const pageSize = Number.isFinite(rawSize) ? Math.min(100, Math.max(1, Math.floor(rawSize))) : 100;
  add("page_size", pageSize);
  add("pair", params.pair != null ? String(params.pair).toUpperCase().replace(/\//g, "") : undefined);
  add("side", params.side != null ? String(params.side).toUpperCase() : undefined);
  add("date_from", params.date_from);
  add("date_to", params.date_to);
  add("type", params.type != null ? String(params.type).toUpperCase() : undefined);
  add("status", params.status);

  return u.toString();
}

/**
 * List payload from spot `GET /me/orders/open|history|trades` responses.
 * Supports `data.items`, top-level `items`, or `data` as an array.
 */
export function spotMeActivityItemsFromResponse(res) {
  if (!res || typeof res !== "object") return [];
  const d = res.data;
  if (Array.isArray(d?.items)) return d.items;
  if (Array.isArray(res.items)) return res.items;
  if (Array.isArray(d)) return d;
  return [];
}
